<template>
    <!-- 搜索页面 -->
    <div class="search-page">
        <!-- 搜索导航栏 -->
        <SearchNav/>
        <!-- 搜索菜单 -->
        <SearchMenu/>
        <!-- 子路由页面 -->
        <router-view/>
    </div>
</template>

<script>
    // 使用命名空间之后的简化方式
    import {createNamespacedHelpers } from "vuex";
    const { mapState, mapMutations } = createNamespacedHelpers('search');
    import SearchMenu from './children/SearchMenu';
    import SearchNav from './children/SearchNav';
    export default {
        name: "SearchPage",
        components:{
            SearchNav,
            SearchMenu
        },
        computed:{
            ...mapState(['input'])
        },
        methods:{
            ...mapMutations(['updateInput','updateActiveName'])
        },
        created(){
            // TODO 设置当前页面无导航栏
            this.$store.commit("nav/typeUpdate",0);
            // TODO 获取子路由名称和用户输入
            this.updateActiveName(this.$route.fullPath.split('/')[2]);
            this.updateInput(this.$route.params.input);
        },

    }
</script>

<style scoped>

</style>